import { $Qll } from './query-selector';

function applyFallback(imgEl, fallbackUrl) {
  if (!imgEl || !fallbackUrl) return;

  if (imgEl.dataset.fallbackApplied === 'true') return;
  imgEl.dataset.fallbackApplied = 'true';

  const picture = imgEl.closest('picture');
  if (picture) {
    picture.querySelectorAll('source').forEach((source) => {
      source.removeAttribute('srcset');
    });
  }

  imgEl.removeAttribute('srcset');
  imgEl.removeAttribute('data-src');
  imgEl.removeAttribute('data-srcset');
  imgEl.classList.remove('lazyload', 'lazyloading');

  imgEl.src = fallbackUrl;
}

function isBroken(imgEl) {
  return imgEl && imgEl.complete && imgEl.naturalWidth === 0;
}

function findLogoImg(root, selector) {
  let img = root.querySelector('img' + selector);
  if (img) return img;

  const picture = root.querySelector('picture' + selector);
  if (picture) {
    img = picture.querySelector('img');
    if (img) return img;
  }

  const container = root.querySelector(selector);
  if (container) {
    img = container.querySelector('img');
    if (img) return img;
  }

  return root.querySelector('img[class*="' + selector.replace('.', '') + '"]');
}

function handle(imgEl, fallbackUrl) {
  if (!imgEl || !fallbackUrl) return;

  if (isBroken(imgEl)) {
    applyFallback(imgEl, fallbackUrl);
    return;
  }

  imgEl.addEventListener(
    'error',
    function onErr() {
      applyFallback(imgEl, fallbackUrl);
    },
    { once: true }
  );

  imgEl.addEventListener(
    'load',
    function onLoad() {
      if (isBroken(imgEl)) applyFallback(imgEl, fallbackUrl);
    },
    { once: true }
  );

  requestAnimationFrame(() => {
    if (isBroken(imgEl)) applyFallback(imgEl, fallbackUrl);
  });
}

export function changeBadLogoImage() {
  const containers = $Qll('.header-logo-js');
  if (!containers || !containers.length) return;

  containers.forEach((container) => {
    const fallbackDesktop = container.dataset.defaultLogo;
    const fallbackMobile = container.dataset.defaultLogoMobile;

    const desktopImg = findLogoImg(container, '.header__logo--desktop');
    const mobileImg = findLogoImg(container, '.header__logo--mobile');

    handle(desktopImg, fallbackDesktop);
    handle(mobileImg, fallbackMobile);
  });
}
